export default __webpack_public_path__ + "static/media/image-homepage-hero@2x.10f998fc.jpg";